import axios from 'axios';
import { baseUrl, token } from '../../../../services/Apis';

export const suscripcionPagosApi = `${baseUrl}/suscripcion-pagos`;

export const allPagosSuscripcionService = async (params) => {
  const res = await axios.get(`${suscripcionPagosApi}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const savePagosSuscripcionService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${suscripcionPagosApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(`${suscripcionPagosApi}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const onePagosSuscripcionService = async (id) => {
  const res = await axios.get(`${suscripcionPagosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deletePagosSuscripcionService = async (id) => {
  const res = await axios.delete(`${suscripcionPagosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
